export default "__VITE_ASSET__BrHz6kDR__"